export default __webpack_public_path__ + "assets/images/c8353c9e905fcdac1a6705a41c3287c9.jpg";